import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import QualValOffering from "@/pages/QualValOffering";

export const Route = createFileRoute("/en/services/qualification-validation/equipment-qualification")({
  head: () => buildRouteHead("/en/services/qualification-validation/equipment-qualification"),
  component: QualValOffering,
});

